
import { apiConstants } from '../_constants'
import { store } from '../_helpers/store';
import { utils } from '../_helpers';

export const walletService = {
    getMemberWallet , getAllAssets  
}

function getMemberWallet(memberId){
    
    return (
        
        utils.Get(`${apiConstants.ENDPOINT}wallet/getmemberwallet/${memberId}`)
        .then(response=>response)
    )
}

function getAllAssets(){
    
    return (
        
        utils.Get(`${apiConstants.ENDPOINT}currency/GetAllAssets`)
        .then(response=>response)
    )
}


// WEBPACK FOOTER //
// ./src/_services/wallet.service.js